import React, { useEffect, useState } from "react";
import * as API from "../../framework/API/api";
import { utility } from "../../framework/utility/utilityProvider";
import { EditPageHeader } from "../../components/EditPageHeader";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import BossDialog from "../../components/BossDialog";
import ToastNotification from "../../components/ToastNotification";
import { ENTITYNAME, TOAST_TYPES } from "../../framework/constant/constant";
import { PROMOTIONS_CAMPAIGN_TYPES, PROMOTIONS_PLATFORM } from "./SocialMediaConstant";
import { useTranslation } from "../../locale/useTranslation";
import moment from "moment";
import { DateCell, DateTimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import { MenuCommandCell } from "../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ";
import MetaInsightsForm from "./MetaInsightsForm";
import PostEditForm from "./PostEditForm";
import PromotionPostHistoryPopup from "./PromotionPostHistoryPopup";
import { ConfirmAlert } from "../../ConfirmAlert";

const waveStyles = `
@keyframes flowingGradientWave {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
}
@keyframes waveBounce {
    0%, 60%, 100% { transform: translateY(0); }
    30% { transform: translateY(-4px); }
}
`;

const PromotionsCampaignEditForm = (props) => {
    const item = props.item;
    const cancelEdit = props.cancelEdit;
    const lang = useTranslation();

    const [dataItem, setDataItem] = useState({
        ...item,
        Title: item?.Title ?? "",
        CampaignType: item?.CampaignType ? { _id: item?.CampaignType, Description: utility.getKeyByValue(PROMOTIONS_CAMPAIGN_TYPES, item.CampaignType) } : { _id: PROMOTIONS_CAMPAIGN_TYPES.EXTERNAL, Description: utility.getKeyByValue(PROMOTIONS_CAMPAIGN_TYPES, PROMOTIONS_CAMPAIGN_TYPES.EXTERNAL) },
        DealAmount: item?.DealAmount || "",
        PromotionsPlatform: item?.PromotionsPlatform ? { _id: item?.PromotionsPlatform, Description: utility.getKeyByValue(PROMOTIONS_PLATFORM, item.PromotionsPlatform) } : { _id: PROMOTIONS_PLATFORM.FACEBOOK, Description: utility.getKeyByValue(PROMOTIONS_PLATFORM, PROMOTIONS_PLATFORM.FACEBOOK) },
        StartDate: item?.StartDate ? utility.convertMilisecondsToDateString(item?.StartDate) : moment().startOf('month').format('YYYY-MM-DD'),
        EndDate: item?.EndDate ? utility.convertMilisecondsToDateString(item?.EndDate) : moment().endOf('month').format('YYYY-MM-DD'),
        Agency: item?.Agency ?? {},
        Client: item?.Client ?? {},
        AttachedPosts: item?.AttachedPosts || [],
        TotalAttachedPosts: item?.TotalAttachedPosts ?? 0,
        PublishPage: item?.PublishPage ?? {},
    });

    const [campaignTypes, setCampaignTypes] = useState([]);
    const [platforms, setPlatforms] = useState([]);
    const [agencies, setAgencies] = useState([]);
    const [clients, setClients] = useState([]);
    const [postData, setPostData] = useState([]);
    const [pages, setPages] = useState([]);
    const [isLoading, setIsLoading] = useState(false)

    const [showAttachPostPopup, setShowAttachPostPopup] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [newAttachment, setNewAttachment] = useState({ Post: {}, StartDate: "", EndDate: "", Amount: "" });
    const [actionLoading, setActionLoading] = useState({ index: null, id: null, action: "" });
    const [showInsightPopup, setShowInsightPopup] = useState({ show: false, item: null });
    const [showHistoryPopup, setShowHistoryPopup] = useState({ show: false, item: null });
    const [showCreatePostPopup, setShowCreatePostPopup] = useState(false);

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        const campaignTypeRes = Object.keys(PROMOTIONS_CAMPAIGN_TYPES).map(k => ({ _id: PROMOTIONS_CAMPAIGN_TYPES[k], Description: k }));
        setCampaignTypes(campaignTypeRes);

        const platformRes = Object.keys(PROMOTIONS_PLATFORM).map(k => ({ _id: PROMOTIONS_PLATFORM[k], Description: k }));
        setPlatforms(platformRes);

        const agencyRes = await API.getDataLookup(ENTITYNAME.Agency, { sort: { Name: 1 } });
        setAgencies(agencyRes?.data);

        const clientRes = await API.getDataLookup(ENTITYNAME.Client, { sort: { Name: 1 } });
        setClients(clientRes?.data);

        const postRes = await API.getDataLookup(ENTITYNAME.SM_PromotionsPosts, { sort: { Title: 1 } });
        setPostData(postRes?.data);
    };

    const loadPages = async (platformID) => {
        if (!platformID) {
          setPages([]);
          return;
        }
        const pagesRes = await API.getData(ENTITYNAME.SM_PromotionsPages, { sort: { Name: 1 },query: [['PromotionsPlatform', '=', platformID]] });
        setPages(pagesRes?.data);
      };

    const handleAddAttachment = () => {
        if (!newAttachment.Post?._id && !newAttachment.Post?.Title) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_a_post_error_message });
            return;
        }

        if (editIndex === null && dataItem.TotalAttachedPosts && (dataItem.AttachedPosts?.length + 1) > Number(dataItem.TotalAttachedPosts)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.number_of_attached_posts_cannot_exceed_total_attached_posts_error_message });
            return;
        }

        if (newAttachment.StartDate && newAttachment.EndDate) {
            const postStart = moment(newAttachment.StartDate);
            const postEnd = moment(newAttachment.EndDate);

            if (postEnd.isBefore(postStart)) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.post_end_date_cannot_be_earlier_than_start_date_error_message });
                return;
            }

            if (dataItem.StartDate && dataItem.EndDate) {
                const campStart = moment(dataItem.StartDate);
                const campEnd = moment(dataItem.EndDate);

                if (postStart.isBefore(campStart) || postEnd.isAfter(campEnd)) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.post_dates_must_be_within_campaign_start_and_end_dates_error_message });
                    return;
                }
            }
        }

        const formattedAttachment = {
            ...newAttachment,
            Post: { _id: newAttachment?.Post?._id, Title: newAttachment?.Post?.Title, Media: newAttachment?.Post?.Media, PromotionsMediaType: newAttachment?.Post?.PromotionsMediaType, isReel: newAttachment?.Post?.isReel },
            StartDate: newAttachment?.StartDate ? utility.convertStringDatetoMilliseconds(newAttachment.StartDate) : null,
            EndDate: newAttachment?.EndDate ? utility.convertStringDatetoMilliseconds(newAttachment.EndDate) : null,
        };
        if (editIndex !== null) {
            setDataItem(prev => {
                const updated = [...prev.AttachedPosts];
                updated[editIndex] = formattedAttachment;
                return { ...prev, AttachedPosts: updated };
            });
        } else {
            setDataItem(prev => ({
                ...prev,
                AttachedPosts: [...prev.AttachedPosts, formattedAttachment]
            }));
        }
        setEditIndex(null);
        setShowAttachPostPopup(false);
        setNewAttachment({ Post: {}, StartDate: "", EndDate: "", Amount: "" });
    };

    const handleDeleteAttachment = (index) => {
        setDataItem(prev => ({
            ...prev,
            AttachedPosts: prev.AttachedPosts.filter((_, i) => i !== index)
        }));
    };

    const handleShowAttachPost  = () => {
        setEditIndex(null);
        setNewAttachment({
            Post: {},
            StartDate: moment().startOf('month').format('YYYY-MM-DD'),
            EndDate: moment().endOf('month').format('YYYY-MM-DD'),
            Amount: 0,
        });
        setShowAttachPostPopup(true);
    };

    const handleEditAttachment = (attachment, index) => {
        setEditIndex(index);
        setNewAttachment({
            Post: attachment.Post ?? {},
            StartDate: attachment?.StartDate ? utility.convertMilisecondsToDateString(attachment.StartDate) : moment().startOf('month').format('YYYY-MM-DD'),
            EndDate: attachment?.EndDate ? utility.convertMilisecondsToDateString(attachment.EndDate) : moment().endOf('month').format('YYYY-MM-DD'),
            Amount: attachment.Amount ?? 0
        });
        setShowAttachPostPopup(true);
    };

    const publishPromotionPost = async (item, index) => {
        if (!dataItem._id) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_save_campaign_first_error_message });
            return;
        }
        if (!dataItem.PublishPage?._id) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_page_for_campaign_error_message });
            return;
        }
        
        setActionLoading({ index, id: item?.Post?._id, action: "Publishing" });
        const payload = {
            pageId: dataItem.PublishPage?._id,
            promotionPostId: item?.Post?._id,
            platform: dataItem.PromotionsPlatform?._id,
            campaignId: dataItem._id
        };

        const res = await API.publishSocialMediaPromotionPosts(payload);
        console.log(res)
        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
            setDataItem(prev => {
                const updated = [...prev.AttachedPosts];
                updated[index] = { ...updated[index], isPublished: true, postId: res.data.postId, history : [...(item.history || []), res.data.history] };
                return { ...prev, AttachedPosts: updated };
            });
            setActionLoading({ index: null, id: null, action: "" });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            setActionLoading({ index: null, id: null, action: "" });
        }
    };

    const unPublishPromotionPost = async (item, index) => {
        if (!item.isPublished) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_publish_post_first_error_message });
            return;
        }
        if (!dataItem.PublishPage?._id) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_page_for_campaign_error_message });
            return;
        }

        ConfirmAlert(
            async () => {
                setActionLoading({ index, id: item?._id || item?.Post?._id, action: "Unpublishing" });
                const payload = {
                    pageId: dataItem.PublishPage?._id,
                    postId: item?.postId,
                    platform: dataItem.PromotionsPlatform?._id,
                    campaignId: dataItem._id,
                    promotionPostId: item.Post._id
                };

                const res = await API.unpublishSocialMediaPromotionPosts(payload);
                if (res.success) {
                    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
                    setDataItem(prev => {
                        const updated = [...prev.AttachedPosts];
                        updated[index] = { ...updated[index], isPublished: false, postId : null, history: [...(item.history || []), res.data.history] };
                        return { ...prev, AttachedPosts: updated };
                    });
                    setActionLoading({ index: null, id: null, action: "" });
                } else {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
                    setActionLoading({ index: null, id: null, action: "" });
                }
            },
            () => {},
            "Confirm Unpublish",
            "Are you sure you want to proceed? Unpublishing this post will permanently remove its likes, shares, and reach."
        );
    };

    console.log(dataItem)

    const promotionsCampaignMenuModel = (props) => {
        const isPublished = props.dataItem?.isPublished === true;
        const items = [
            { label: 'Edit', icon: 'pi pi-pencil', command: () => props.onEdit(props.dataItem, props.dataIndex) }
        ];

        if (isPublished) {
            items.push({ label: 'Insights', icon: 'pi pi-chart-bar', command: () => setShowInsightPopup({ show: true, item: props.dataItem }) });
        } else {
            const historyList = props.dataItem?.history || [];
            const savedInsights = [...historyList].reverse().find(h => h.insights);
            const hasStoredInsights = Boolean(savedInsights?.insights && (Object.keys(savedInsights?.insights).length > 0));
            if (hasStoredInsights) {
                items.push({ label: 'Last Insights', icon: 'pi pi-chart-bar', command: () => setShowInsightPopup({ show: true, item: props.dataItem, savedInsights: savedInsights?.insights }) });
            }
            items.push({ label: 'Delete', icon: 'pi pi-trash', command: () => props.onDelete(props.dataIndex) });
        }

        items.push({
            label: 'History',
            icon: 'pi pi-history',
            command: () => {
                if (!props.dataItem?.history || props.dataItem.history.length === 0) {
                    ToastNotification({ type: TOAST_TYPES.INFO, title: lang.invalid_error_message_title, message: lang.publish_history_error_message });
                } else {
                    setShowHistoryPopup({ show: true, item: props.dataItem });
                }
            }
        });

        items.push(
            { label: 'Publish', icon: 'pi pi-arrow-up', command: () => props.onPublish(props.dataItem, props.dataIndex, true) },
            { label: 'Unpublish', icon: 'pi pi-arrow-down', command: () => props.onUnPublish(props.dataItem, props.dataIndex, false) }
        );

        return [
            {
                label: 'Options',
                items: items
            }
        ];
    };

    const MyCommandCell = (cell) => (
        <MenuCommandCell
            {...cell}
            onDelete={handleDeleteAttachment}
            onEdit={handleEditAttachment}
            onPublish={publishPromotionPost}
            onUnPublish={unPublishPromotionPost}
            myMenuModel={promotionsCampaignMenuModel}
        />
    );

    const PostPublishStatusCell = ({ dataItem, dataIndex }) => {
        const isRowLoading = actionLoading.index === dataIndex || (actionLoading.id && (dataItem?._id === actionLoading.id || dataItem?.Post?._id === actionLoading.id));
        if (isRowLoading) {
            return (
                <td>
                    <style>{waveStyles}</style>
                    <div 
                        className="badge text-white px-2 py-2 fs-6 d-flex align-items-center justify-content-center shadow-sm"
                        style={{
                            minWidth: '100px',
                            width: 'fit-content',
                            background: 'linear-gradient(270deg, #0d6efd, #00c6ff, #0072ff, #0d6efd)',
                            backgroundSize: '300% 300%',
                            animation: 'flowingGradientWave 2s ease infinite',
                            border: '1px solid rgba(255,255,255,0.3)'
                        }}
                    >
                        <span>{actionLoading.action}</span>
                        <div className="d-flex align-items-center" style={{ gap: '3px', marginLeft: '10px' }}>
                            <span style={{ display: 'inline-block', width: '4px', height: '4px', backgroundColor: '#fff', borderRadius: '50%', animation: 'waveBounce 1.2s infinite ease-in-out', animationDelay: '0s' }}></span>
                            <span style={{ display: 'inline-block', width: '4px', height: '4px', backgroundColor: '#fff', borderRadius: '50%', animation: 'waveBounce 1.2s infinite ease-in-out', animationDelay: '0.2s' }}></span>
                            <span style={{ display: 'inline-block', width: '4px', height: '4px', backgroundColor: '#fff', borderRadius: '50%', animation: 'waveBounce 1.2s infinite ease-in-out', animationDelay: '0.4s' }}></span>
                        </div>
                    </div>
                </td>
            );
        }

        const isPublished = dataItem?.isPublished === true;
        const status = isPublished ? lang.published_label : lang.unpublished_label;
        const statusClass = isPublished ? 'bg-success text-white' : 'bg-danger text-white';

        return (
            <td>
                <div className={`badge ${statusClass} px-3 py-2 fs-6`}>
                    {status}
                </div>
            </td>
        );
    };

     

    const isValid = () => {
        if (!dataItem.Title || dataItem.Title.trim() === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_title_error_message });
            return false;
        }
        if (!dataItem.DealAmount || dataItem.DealAmount <= 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_deal_amount_error_message });
            return false;
        }
        if (!dataItem.PublishPage || Object.keys(dataItem.PublishPage).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_page_for_campaign_error_message });
            return false;
        }
        if (dataItem.StartDate && dataItem.EndDate && moment(dataItem.EndDate).isBefore(moment(dataItem.StartDate))) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.campaign_end_date_cannot_be_earlier_than_start_date_error_message });
            return false;
        }
        if (!dataItem.AttachedPosts || dataItem.AttachedPosts.length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_at_least_one_post_error_message });
            return false;
        }
        if (dataItem.TotalAttachedPosts && (dataItem.AttachedPosts?.length) > Number(dataItem.TotalAttachedPosts)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.number_of_attached_posts_cannot_exceed_total_attached_posts_error_message });
            return false;
        }
        return true;
    };

    const onChange = async (e) => {
        const { name, value } = e.target;
        if (e.target.name == "PromotionsPlatform") {
            setDataItem({...dataItem,PromotionsPlatform: e.target.value,PubishPage:{}});
            await loadPages(e.target.value?._id);
        }
        else{
            setDataItem({...dataItem, [name]: value});
        }
    };

    const handleAttachmentChange = (e) => {
        const { name, value } = e.target;
        setNewAttachment(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (!isValid()) return;
        try {

            const finalData = {
                ...item,
                _id: dataItem._id,
                SID: dataItem.SID,
                Title: dataItem.Title,
                CampaignType: dataItem.CampaignType._id,
                DealAmount: dataItem.DealAmount,
                TotalAttachedPosts: dataItem.TotalAttachedPosts,
                PromotionsPlatform: dataItem.PromotionsPlatform._id,
                StartDate: dataItem.StartDate ? utility.convertStringDatetoMilliseconds(dataItem.StartDate) : null,
                EndDate: dataItem.EndDate ? utility.convertStringDatetoMilliseconds(dataItem.EndDate) : null,
                Agency: dataItem?.Agency && Object.keys(dataItem?.Agency).length > 0 ? { _id: dataItem.Agency?._id, Name: dataItem.Agency?.Name } : {},
                Client: dataItem?.Client && Object.keys(dataItem?.Client).length > 0 ? { _id: dataItem.Client?._id, Name: dataItem.Client?.Name } : {},
                AttachedPosts: dataItem.AttachedPosts,
                PublishPage: dataItem?.PublishPage && Object.keys(dataItem?.PublishPage).length > 0 ? {_id: dataItem.PublishPage?._id,Name:dataItem.PublishPage?.Name}:{}
            };

            const res = await API.saveData(ENTITYNAME.SM_PromotionsCampaigns, finalData);
            if (res.success) {
                utility.deleteLocalStorageItem(ENTITYNAME.SM_PromotionsCampaigns);
                if (props.refresh) props.refresh();
                if (cancelEdit) cancelEdit();
                if (props.onSaveData) props.onSaveData(res.data);
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: "Error", message: res.message });
            }
        } catch (err) {
            console.error("Save error:", err);
            ToastNotification({ type: TOAST_TYPES.ERROR, title: "Error", message: "Unexpected save error" });
        }
    };

    return (
        <BossDialog title={dataItem?._id ? lang.edit_campaign_header : lang.create_campaign_header } onClose={cancelEdit} width="950px" height="auto">
            <div className="p-2">
                <EditPageHeader onSubmit={handleSubmit} isLoading={isLoading} onCancel={cancelEdit} showTitle={false}/>
                <div className="row mt-2">
                    <div className="col-3 form-group">
                        <label htmlFor="title">{lang.title_label} *</label>
                        <input
                            id="title"
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Enter Title"
                            name="Title"
                            value={dataItem.Title}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-3 form-group">
                        <label htmlFor="CampaignType">{lang.campaign_type_column} *</label>
                        <DropDownList
                            id="CampaignType"
                            data={campaignTypes}
                            textField="Description"
                            dataItemKey="_id"
                            className="bg-white"
                            value={dataItem.CampaignType}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-3 form-group">
                        <label htmlFor="DealAmount">{lang.deal_amount_label} *</label>
                        <input
                            name="DealAmount"
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Enter Amount"
                            value={dataItem.DealAmount}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-3 form-group">
                        <label htmlFor="TotalAttachedPosts">{lang.total_attached_post_label}</label>
                        <input
                            type="number"
                            id="TotalAttachedPosts"
                            name="TotalAttachedPosts"
                            className="form-control form-control-sm"
                            value={dataItem.TotalAttachedPosts}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-3 form-group">
                        <label htmlFor="PromotionsPlatform">{lang.platform_label} *</label>
                        <DropDownList
                            data={platforms}
                            name="PromotionsPlatform"
                            textField="Description"
                            dataItemKey="_id"
                            className="bg-white"
                            value={dataItem.PromotionsPlatform}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-3 form-group">
                        <label htmlFor="PublishPage">{lang.publish_page_label} *</label>
                        <DropDownList
                            data={pages}
                            name="PublishPage"
                            textField="Name"
                            dataItemKey="_id"
                            className="bg-white"
                            value={dataItem.PublishPage}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-3 form-group">
                        <label htmlFor="StartDate">{lang.start_date_label}</label>
                        <input
                            type="date"
                            name="StartDate"
                            className="form-control form-control-sm"
                            value={dataItem.StartDate}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-3 form-group">
                        <label htmlFor="EndDate">{lang.end_Date_label}</label>
                        <input
                            type="date"
                            name="EndDate"
                            className="form-control form-control-sm"
                            value={dataItem.EndDate}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-6 form-group">
                        <label htmlFor="Agency">{lang.agency_label} </label>
                        <DropDownList
                            data={agencies}
                            name="Agency"
                            textField="Name"
                            dataItemKey="_id"
                            className="bg-white"
                            value={dataItem.Agency}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6 form-group">
                        <label htmlFor="Client">{lang.client_label}</label>
                        <DropDownList
                            data={clients}
                            name="Client"
                            textField="Name"
                            dataItemKey="_id"
                            className="bg-white"
                            value={dataItem.Client}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="row mt-3 p-2">
                    <div className="flex items-center ml-2">
                        <AddRoundButton name="Attach Post" onClick={handleShowAttachPost} title="Add Post" icon="plus" />
                    </div>
                </div>

                <div className="p-2">
                    <Grid data={dataItem.AttachedPosts || []} style={{ height: "250px" }}>
                        <GridColumn cell={MyCommandCell} width="60px" />
                        <GridColumn field="isPublished" width="140px" title={lang.status_label || "Status"} cell={PostPublishStatusCell} />
                        <GridColumn field="Post.Title" title={lang.title_label}/>
                        <GridColumn field="StartDate" title={lang.start_date_label} cell={DateCell} width="180px"/>
                        <GridColumn field="EndDate" title={lang.end_Date_label} cell={DateCell} width="180px"/>
                        <GridColumn field="Amount" title={lang.amount_label} width="150px"/>
                    </Grid>
                </div>
            </div>

            {/* Child Modal for Post Attachment */}
            {showAttachPostPopup && (
                <BossDialog title="Attach Post" onClose={() => { setShowAttachPostPopup(false); setEditIndex(null); }} width="500px" height="auto">
                    <div className="p-1">
                       <div className="row mb-1">
                        <div className="col-6 form-group">
                            <label htmlFor="Post">{lang.post_label} *</label>
                            <div className="d-flex align-items-center">
                                <DropDownList
                                    style={{ backgroundColor: 'white' }}
                                    data={postData}
                                    name="Post"
                                    textField="Title"
                                    dataItemKey="_id"
                                    className="flex-grow-1"
                                    value={newAttachment.Post}
                                    onChange={handleAttachmentChange}
                                />
                                <button
                                    type="button"
                                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                                    style={{ height: "29px", margin: '0px 0px 0px 5px' }}
                                    title="Create New Post"
                                    onClick={() => setShowCreatePostPopup(true)}
                                >
                                    <i className="fa-solid fa-plus fa-xs"></i>
                                </button>
                            </div>
                        </div>
                        <div className="col-6 form-group">
                            <label htmlFor="Amount">{lang.amount_label}</label>
                            <input
                                type="number"
                                name="Amount"
                                className="form-control form-control-sm"
                                placeholder="Enter Amount"
                                value={newAttachment.Amount}
                                onChange={handleAttachmentChange}
                            />
                        </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6 form-group">
                                <label htmlFor="StartDate">{lang.start_date_label}</label>
                                <input
                                    type="date"
                                    name="StartDate"
                                    className="form-control form-control-sm"
                                    value={newAttachment.StartDate}
                                    onChange={handleAttachmentChange}
                                />
                            </div>
                            <div className="col-6 form-group">
                                <label htmlFor="EndDate">{lang.end_Date_label}</label>
                                <input
                                    type="date"
                                    name="EndDate"
                                    className="form-control form-control-sm"
                                    value={newAttachment.EndDate}
                                    onChange={handleAttachmentChange}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-end">
                            <button type="button" className="btn btn-secondary btn-sm mr-2" onClick={() => { setShowAttachPostPopup(false); setEditIndex(null); }}>{lang.cancel_button_tooltip}</button>
                            <button type="button" className="btn btn-primary btn-sm" style={{ marginLeft: "8px" }} onClick={handleAddAttachment}>{lang.attach_button_tooltip}</button>
                        </div>
                    </div>
                </BossDialog>
            )}

            {showHistoryPopup.show && (
                <PromotionPostHistoryPopup
                    item={showHistoryPopup.item}
                    onClose={() => setShowHistoryPopup({ show: false, item: null })}
                />
            )}

            {showInsightPopup.show && (
                <MetaInsightsForm
                    item={showInsightPopup.item}
                    pageId={dataItem.PublishPage?._id}
                    platform={dataItem.PromotionsPlatform?._id}
                    savedInsights={showInsightPopup.savedInsights}
                    onClose={() => setShowInsightPopup({ show: false, item: null, savedInsights: null })}
                />
            )}

            {showCreatePostPopup && (
                <PostEditForm
                    item={{}}
                    cancelEdit={() => setShowCreatePostPopup(false)}
                    onSaveData={(newPost) => {
                        if (newPost) {
                            setPostData(prev => [newPost, ...(prev || []).filter(p => p._id !== newPost._id)]);
                            setNewAttachment(prev => ({ ...prev, Post: newPost }));
                        }
                        setShowCreatePostPopup(false);
                    }}
                    refresh={loadCombo}
                />
            )}
        </BossDialog>
    );
};

export default PromotionsCampaignEditForm;
